// extracted by mini-css-extract-plugin
export default {"contato":"contato_contato__nQ2xW","redes":"contato_redes__bSazE"};